<template>
  <div>
    <label>Notification</label>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        :style="`${
          selectedNotification != '' && selectedNotification != null
            ? 'border-right:0px'
            : 'border-radius:5px'
        }`"
        name="inpsel_equipment_id"
        autocomplete="off"
        placeholder="Notification"
        @input="updateNotificationId()"
        @change="updateNotificationId()"
        v-model="selectedNotification"
        list="notification-list"
        id="inpsel_equipid"
      />
      <datalist id="notification-list">
        <option
          :value="notification.name"
          :data-id="notification.id"
          v-for="notification in store.custom.notificationList"
          :key="notification"
        >
          {{ notification.name }}
        </option>
      </datalist>
      <button
        @click="selectedNotification = ''"
        v-if="selectedNotification != null && selectedNotification != ''"
        class="btn"
        style="
          border-left: 0px;
          border-top: 1px #dee2e6 solid;
          border-right: 1px #dee2e6 solid;
          border-bottom: 1px solid #dee2e6;
          color: #0000008a;
        "
        type="button"
      >
        <i class="fas fa-xmark"></i>
      </button>
    </div>
    <div
      class="d-flex justify-content-end gap-2 pt-3 pb-1 mt-5"
      style="border-top: 1px #00000022 solid"
    >
      <button type="button" class="btn btn-success" @click="handleSendReward(0)">Send</button>
      <button type="button" class="btn btn-secondary" @click="emit('close')">Close</button>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, ref } from "vue";
import store from "node-back-client/src/store";

const selectedNotification = ref(null);
const selectedNotifId = ref(null);

const emit = defineEmits(['close','sendReward'])



const updateNotificationId = () => {
  const selectedOption = document.querySelector(
    `#notification-list option[value='${selectedNotification.value}']`
  );
  if (selectedOption) {
    selectedNotifId.value = parseInt(selectedOption.getAttribute("data-id"));
  }
};

const handleSendReward = (type) => {
  emit('sendReward',type, selectedNotifId.value, selectedNotification.value)
} 


</script>

<style lang="scss" scoped></style>
